import $ from 'jquery'
import 'jquery-mask-plugin'
import { initMultipleSlider } from 'application/shared/sliders'
import 'application/shared/create_wish_using_explanation_and_lead_form'

_require [
  'jquery/select2v3',
], ->
  initMultipleSlider()

  amount = $('.amount')

  if amount.length
    amount.mask('99999,99', { reverse: true })

  sticky_table = $("table.sticky-table-headers")

  if sticky_table.length
    _require ['jquery/stickytableheaders'], ->
      #---------------------------------------------------
      # Mantem header de tabela no topo depois de scroll
      #---------------------------------------------------
      sticky_table.stickyTableHeaders()

  $("#modal-sim-submit").click ->
    $("#simulator-form-modal").modal('toggle')
    return

  $(".form").submit ->
    setTimeout (->
      location.href = "#results"
      return
    ), 1000

  $('.income_range').select2V3(
    containerCssClass: 'qb-s2v3'
    dropdownCssClass: 'qb-s2v3'
    minimumResultsForSearch: -1
    placeholder: 'Renda familiar')
  .on 'select2-opening', ->
    $(this).closest('li').find('input')
    .attr 'placeholder', 'Renda familiar'
    return

  $('.remaining_semesters').select2V3(
    containerCssClass: 'qb-s2v3'
    dropdownCssClass: 'qb-s2v3'
    minimumResultsForSearch: -1
    placeholder: 'Duração do Curso')
  .on 'select2-opening', ->
    $(this).closest('li').find('input')
    .attr 'placeholder', 'Duração do Curso'
    return

  if $('[name="interest[course]"]').length > 0
    _require ['canonical_selector_v4'], ->
      $('.js-canonical-selector').prop('disabled', false)
      canonicalSelect = new QB.CanonicalSelectorV4()
      canonicalSelect.init('.js-canonical-selector', { idVal: 1 })
